// Admin bo'limi: layout, Users, Branches & teams, Audit log (ru)
export default {
  tabs: {
    users: "Пользователи",
    branches: "Филиалы",
    settings: "Настройки",
    import: "Импорт из Sheets",
    audit: "Журнал аудита",
  },
  audit: {
    title: "Журнал аудита",
    ownerOnly: "Только для владельца",
    ownerOnlyDesc: "Журнал аудита доступен только владельцу.",
    readOnly: "Только чтение",
    subtitle: "Каждое изменение в системе · только владелец",
    userAll: "Пользователь: все",
    modelAll: "Тип объекта: все",
    actionPlaceholder: "Действие (update, login…)",
    searchPlaceholder: "Поиск по объекту, имени водителя, ID",
    emptyTitle: "Событий нет",
    emptyFiltered: "Ничего не подходит под эти фильтры.",
    emptyDesc: "Изменения будут появляться здесь по мере работы.",
    col: { time: "Время", user: "Пользователь", action: "Действие", object: "Объект", change: "Изменение (было → стало)", ip: "IP" },
    events: "событий",
    system: "система",
    yes: "да",
    no: "нет",
    more: "ещё {{n}}",
    requestId: "ID запроса",
    field: "Поле",
    old: "Было",
    new: "Стало",
    immutable: "Записи журнала аудита нельзя изменить или удалить.",
    model: {
      all: "Все объекты",
      auth: "Вход",
      user: "Пользователь",
      branch: "Филиал",
      driver: "Водитель",
      application: "Заявка",
      carrier: "Перевозчик",
      job: "Вакансия",
      approval: "Согласование",
      setting: "Настройки",
      expense: "Расход",
      salary: "Зарплата",
      bonus: "Бонус",
      driverdocument: "Документ водителя",
    },
  },
  branches: {
    title: "Филиалы",
    subtitle_one: "{{count}} филиал · {{recruiters}} рекрутеров",
    subtitle_few: "{{count}} филиала · команд: {{teams}} · рекрутеров: {{recruiters}}",
    subtitle_many: "{{count}} филиалов · команд: {{teams}} · рекрутеров: {{recruiters}}",
    subtitle_other: "{{count}} филиалов · {{recruiters}} рекрутеров",
    newBranch: "+ Новый филиал",
    emptyTitle: "Филиалов пока нет",
    emptyDesc: "Создайте первый филиал, затем добавьте рекрутеров.",
    card: "Филиалы",
    col: { branch: "Филиал", manager: "Менеджеры", timezone: "Часовой пояс", recruiters: "Рекрутеры" },
    tz: {
      title: "Часовые пояса",
      branchTime: "Время филиала",
      branchTimeDesc: "У каждого филиала свой часовой пояс (выше)",
      driverTime: "Время водителя",
      driverTimeDesc: "По штату водителя: CST, EST, MST, PST",
      reminders: "Напоминания",
      remindersDesc: "Задаются по времени водителя, показываются в обоих",
      today: "«Сегодня» в отчётах",
      todayDesc: "Время филиала",
      tashkent: "Ташкент",
      chicago: "Чикаго",
      newYork: "Нью-Йорк",
      losAngeles: "Лос-Анджелес",
    },
    kv: { manager: "Менеджеры", timezone: "Часовой пояс", hours: "Рабочие часы", address: "Адрес", recruiters: "Рекрутеры" },
    assignHint: "Менеджеры и рекрутеры назначаются в Пользователи → Изменить.",
    managerHint: "Менеджер назначается в Пользователи → Изменить.",
    editTitle: "Изменить {{name}}",
    newTitle: "Новый филиал",
    create: "Создать филиал",
    name: "Название",
    namePlaceholder: "Филиал E",
    code: "Код",
    codePlaceholder: "E",
    hoursHint: "Например 17:00–02:00 Ташкент (день водителей)",
    nameRequired: "Название обязательно.",
    codeRequired: "Код обязателен.",
    saved: "Филиал сохранён",
    created: "Филиал создан",
    saveFailed: "Не удалось сохранить филиал.",
  },
  users: {
    title: "Пользователи",
    subtitle_one: "пользователей: {{count}} · {{branches}} филиал",
    subtitle_few: "пользователей: {{count}} · {{branches}} филиала",
    subtitle_many: "пользователей: {{count}} · {{branches}} филиалов",
    subtitle_other: "пользователей: {{count}} · {{branches}} филиала",
    newUser: "+ Новый пользователь",
    searchPlaceholder: "Поиск по имени или логину",
    roleAll: "Роль: все",
    branchAll: "Филиал: все",
    statusAll: "Статус: все",
    active: "Активен",
    blocked: "Заблокирован",
    emptyFiltered: "Нет пользователей по этим фильтрам",
    emptyTitle: "Пользователей пока нет",
    emptyDesc: "Добавьте команду через «+ Новый пользователь».",
    col: { name: "Имя", role: "Роль", branch: "Филиал", drivers: "Водители", lastLogin: "Последний вход", twofa: "2FA", status: "Статус", actions: "Действия" },
    never: "Ещё не входил",
    alsoIn: "также {{names}}",
    on: "Вкл",
    off: "Выкл",
    users: "пользователей",
    unblock: "Разблокировать",
    block: "Заблокировать",
    cannotBlockSelf: "Нельзя заблокировать себя",
    moreActions: "Другие действия",
    setPassword: "Выдать новый пароль…",
    reset2fa: "Сбросить 2FA",
    unblocked: "{{name}} разблокирован",
    passwordSet: "Новый пароль для {{name}} задан",
    twofaReset: "2FA сброшена для {{name}}",
    actionFailed: "Действие не выполнено",
    form: {
      editTitle: "Изменить {{name}}",
      newTitle: "Новый пользователь",
      newDesc: "Временный пароль задаёте вы и передаёте сотруднику; при первом входе он его сменит.",
      create: "Создать",
      firstName: "Имя",
      lastName: "Фамилия",
      username: "Логин",
      usernamePlaceholder: "imya.familiya",
      password: "Временный пароль",
      passwordHint: "Не менее 10 символов. После сохранения будет показан ещё раз.",
      random: "Случайный",
      role: "Роль",
      phone: "Телефон",
      branch: "Филиал",
      chooseBranch: "Выберите филиал",
      extraBranches: "Дополнительные филиалы",
      extraBranchesHint: "Кроме основного филиала. У филиала может быть несколько менеджеров.",
      nothingToChoose: "Пока не из чего выбрать.",
      firstNameRequired: "Имя обязательно.",
      usernameInvalid: "3-30 символов: строчные латинские буквы, цифры, точка, подчёркивание или дефис.",
      passwordShort: "Не менее 10 символов.",
      branchRequired: "Для этой роли нужен филиал.",
      saved: "Пользователь сохранён",
      created: "Пользователь создан",
    },
    credentials: {
      title: "Данные для входа: {{name}}",
      desc: "Показывается один раз. Передайте лично или личным сообщением; при первом входе сотрудник задаст свой пароль.",
      username: "Логин",
      password: "Временный пароль",
      copyAll: "Копировать оба",
      done: "Готово",
    },
    setPasswordModal: {
      title: "Новый пароль для {{name}}",
      desc: "Текущий пароль сразу перестанет работать. При первом входе сотрудник его сменит.",
      password: "Временный пароль",
      random: "Случайный",
      save: "Задать пароль",
      failed: "Не удалось задать пароль.",
      saveFailed: "Не удалось сохранить пользователя.",
    },
    blockModal: {
      title: "Заблокировать {{name}}?",
      blockReassign: "Заблокировать и переназначить",
      block: "Заблокировать",
      body: "{{name}} будет разлогинен и больше не сможет войти. Ничего не удаляется: история и журнал аудита остаются.",
      work: "Что будет с работой: {{first}}",
      drivers_one: "{{count}} водитель",
      drivers_few: "{{count}} водителя",
      drivers_many: "{{count}} водителей",
      drivers_other: "{{count}} водителя",
      reassignAll: "Переназначить всех одному рекрутеру",
      chooseRecruiter: "Выберите рекрутера",
      returnToPool: "Вернуть в пул {{branch}} (назначает {{manager}})",
      noDrivers: "Нет водителей для переназначения.",
      notify: "Уведомить {{manager}} и нового владельца",
      notifyManager: "Уведомить {{manager}}",
      chooseRecruiterError: "Выберите рекрутера, который получит водителей.",
      blocked: "{{name}} заблокирован.",
      moved_one: "Перемещён {{count}} водитель.",
      moved_few: "Перемещено {{count}} водителя.",
      moved_many: "Перемещено {{count}} водителей.",
      moved_other: "Перемещено {{count}} водителя.",
      failed: "Не удалось заблокировать пользователя.",
    },
  },
  // Ruxsatlar oynasi (owner): filial menejeri va team lead uchun
  access: {
    open: "Права доступа",
    title: "Права доступа · {{name}}",
    intro: {
      branch_manager: "Менеджер филиала видит только свои филиалы. Выберите, что ему доступно внутри них.",
    },
    groups: { sections: "Разделы", drivers: "Водители", carriers: "Перевозчики и вакансии" },
    perm: {
      reports: { label: "Отчёты", desc: "Страница отчётов по своему филиалу" },
      approvals: { label: "Согласования", desc: "Видит и решает запросы на найм, перевод и расходы. Если выключено, запросы идут владельцу." },
      budget: { label: "Бюджет и расходы", desc: "Обзор бюджета филиала, план и расходы" },
      pay: { label: "Зарплаты и бонусы", desc: "Видит и устанавливает зарплаты и бонусы сотрудников, в том числе в профилях" },
      users: { label: "Управление сотрудниками", desc: "Админ → Пользователи: добавляет, изменяет и блокирует рекрутеров" },
      drivers_sensitive: { label: "Конфиденциальные данные", desc: "Видит и меняет полную дату рождения и номер CDL" },
      drivers_transfer: { label: "Передача водителей", desc: "Передаёт водителя другому рекрутеру или в общий пул" },
      drivers_archive: { label: "Архивирование водителей", desc: "Архивирует водителей и возвращает их из архива" },
      carriers_edit: { label: "Добавление и изменение", desc: "Добавляет, меняет и архивирует перевозчиков и вакансии. Просмотр открыт всем." },
    },
    custom: "изменено",
    customHint: "Права отличаются от стандартных для роли",
    reset: "Сбросить к стандарту роли",
    applyNote: "Изменения действуют сразу, входить заново не нужно.",
    saved: "Права сохранены · {{name}}",
    conflict: "Эти права только что изменил кто-то другой. Показана последняя версия.",
    notEditable: "Права задаются только менеджерам филиалов.",
    roleChangeHint: "При смене роли особые права сбрасываются к стандарту новой роли.",
  },
};
